import { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchCountriesRequest, resetCountriesFailure } from '../../actions/fetchCountriesActions';
import {
  alpha3CountriesSelector,
  fetchCountriesLoadingSelector,
  fetchCountriesErrorSelector,
  residenceCountrySelector,
} from '../../reducers/selectors';

const useCountries = () => {
  const [reload, setReload] = useState(0);
  const dispatch = useDispatch();
  const data = useSelector(alpha3CountriesSelector);
  const isLoading = useSelector(fetchCountriesLoadingSelector);
  const error = useSelector(fetchCountriesErrorSelector);
  const selectedResidence = useSelector(residenceCountrySelector);

  useLayoutEffect(() => {
    if (!error && !isLoading && data.length === 0) {
      dispatch(fetchCountriesRequest());
    }
  }, [dispatch, data, error, isLoading]);

  const reset = () => {
    dispatch(resetCountriesFailure());
    setReload(reload + 1);
  };

  return {
    data,
    isLoading,
    error,
    reload: () => reset(),
    retries: reload,
    selectedResidence,
  };
};

export default useCountries;
